import { useRouteContext } from '@tanstack/react-router';

export function useOrderRepository() {
  const repository = useRouteContext({
    strict: false,
    select: (context) => context.orderRepository,
  });

  if (!repository) throw new Error('OrderRepository must be provided in context');

  return repository;
}
